import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { ApiContainer } from "../../utils/api";
import { SET_API_DATA } from "../../redux/constants";

const adminAssessment = () => {
  const { locationId, userId } = useParams();
  const { api } = ApiContainer();
  const dispatch = useDispatch();
  const { organization_original_id, permissions } =
    useSelector((state) => state?.app?.userData?.user_profile) ?? {};
  const { AssessmentReport: AssessmentReportLoader, releaseAllLoader } =
    useSelector((state) => state.api.loader);
  const { sendWelcomeEmail: loaderSendWelcomeEmail } = useSelector(
    (state) => state.api.loader
  );
  const {
    AssessmentReport: AssessmentResult,
    assessmentUserInfo,
    currentAssessmentCardUserId,
  } = useSelector((state) => state.api);
  const documentReportList = useSelector(
    (state) => state.api.documentReportList
  );
  const documentReportListLoader = useSelector(
    (state) => state.api?.loader?.documentReportList
  );
  const modelState = useSelector((state) => state?.modelStates);
  const [dialogBox, setDialogBox] = useState(false);
  const [documentDownloaded, setDocumentDownloaded] = useState({});

  const getAssessmentReport = async () => {
    const response = await api({
      method: "GET",
      endPoint: `organization/${organization_original_id}/locations/${locationId}/members/${userId}/assessments`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "AssessmentReport",
    });

    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          AssessmentReport: response.data,
        },
      });
    } else {
      dispatch({
        type: SET_API_DATA,
        payload: {
          AssessmentReport: [],
        },
      });
    }
  };

  const getDocumentReportList = async () => {
    const response = await api({
      method: "GET",
      endPoint: `/document/users/${userId}`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "documentReportList",
    });

    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          documentReportList: response.data,
        },
      });
    } else {
      dispatch({
        type: SET_API_DATA,
        payload: {
          documentReportList: [],
        },
      });
    }
  };

  const releaseAllAssessment = async () => {
    const response = await api({
      method: "POST",
      endPoint: `organization/${organization_original_id}/locations/${locationId}/members/${userId}/assessments/release-all`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "releaseAllLoader",
    });
    getAssessmentReport();
  };

  const handelSendWelcomeEmail = async () => {
    let endPoint = `organization/${organization_original_id}`;

    if (locationId) {
      endPoint += `/locations/${locationId}`;
    }

    if (assessmentUserInfo?.department_original_id) {
      endPoint += `/departments/${assessmentUserInfo?.department_original_id}`;
    }

    endPoint += `/members/${userId}/send-welcome-email`;
    setDialogBox(false);
    if (userId) {
      const data = await api({
        method: "POST",
        endPoint,
        showToastMessage: true,
        urlencoded: false,
        needLoader: true,
        parent: "sendWelcomeEmail",
      });
      if (data?.status) {
        setDialogBox(false);
      }
    }
  };

  const getUserDetail = async () => {
    const response = await api({
      method: "GET",
      endPoint: `user/${userId}/info`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "releaseAllLoader",
    });
    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          assessmentUserInfo: response.data,
        },
      });
    }
    // else {
    //   dispatch({
    //     type: SET_API_DATA,
    //     payload: {
    //       assessmentUserInfo: [],
    //     },
    //   });
    // }
  };

  const handleDocumentDownload = async (url, id) => {
    setDocumentDownloaded((prev) => ({ ...prev, [id]: true }));
    if (url) {
      const fileName = "document.pdf";
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      setDocumentDownloaded((prev) => ({ ...prev, [id]: false }));
    }
  };

  useEffect(() => {
    if (locationId && userId && organization_original_id) {
      getUserDetail();
      getAssessmentReport();
    }
  }, [organization_original_id]);

  useEffect(() => {
    if (userId) {
      getDocumentReportList();
    }
  }, [userId]);

  return {
    AssessmentResult,
    AssessmentReportLoader,
    locationId,
    userId,
    releaseAllAssessment,
    releaseAllLoader,
    assessmentUserInfo,
    permissions,
    dialogBox,
    setDialogBox,
    handelSendWelcomeEmail,
    loaderSendWelcomeEmail,
    dispatch,
    modelState,
    documentReportList,
    documentReportListLoader,
    documentDownloaded,
    handleDocumentDownload,
  };
};

export default adminAssessment;
